import store from 'redux-store/store';
import { serviceSettings } from './constants/serviceSettings';

export const getServiceSettings = () => {
  const { appSettings } = store.getState().settings;
  const settings = appSettings && Object.keys(appSettings).length ? appSettings : undefined;

  return {
    ...serviceSettings,
    settings
  };
};
